import type { TyreDetail } from '@chukua/common';
import { Descriptions } from 'antd';
import { Link } from 'react-router';
import { trailerTabPath } from '../../../../fleet/features/trailers/trailers.paths';
import { truckTabPath } from '../../../../fleet/features/trucks/trucks.paths';
import { unitPath } from '../../../../fleet/features/units/units.paths';
import { formatMoney } from '../../../../../shared/policies/format-money';
import { formatDepth, formatKm } from '../policies/tyre-labels';

/** The Tyres tab of the unit the tyre is on, which draws the truck and its trailer together; by id when the registration isn't known. */
function vehicleTyresPath(fitment: NonNullable<TyreDetail['fitment']>): string {
  if (fitment.vehicleRegistration) return unitPath(fitment.vehicleRegistration, 'tyres');
  return fitment.vehicleKind === 'truck' ? truckTabPath(fitment.vehicleId, 'tyres') : trailerTabPath(fitment.vehicleId, 'tyres');
}

/** The tyre's particulars and where it is now, as a read-only list. */
export function TyreSummary({ tyre }: { tyre: TyreDetail }) {
  const { fitment } = tyre;
  const fitted = fitment ? (
    <Link to={vehicleTyresPath(fitment)}>
      {fitment.vehicleRegistration ?? 'Vehicle'} · {fitment.positionCode}
    </Link>
  ) : (
    '—'
  );

  return (
    <Descriptions column={{ xs: 1, md: 2 }} bordered size="small">
      <Descriptions.Item label="Brand">{tyre.brand}</Descriptions.Item>
      <Descriptions.Item label="Size">{tyre.size}</Descriptions.Item>
      <Descriptions.Item label="Pattern">{tyre.pattern}</Descriptions.Item>
      <Descriptions.Item label="Purchase price">{formatMoney(tyre.cost)}</Descriptions.Item>
      <Descriptions.Item label="Supplier">{tyre.supplierName ?? '—'}</Descriptions.Item>
      <Descriptions.Item label="Purchased">{tyre.purchasedOn}</Descriptions.Item>
      <Descriptions.Item label="Fitted on">{fitted}</Descriptions.Item>
      <Descriptions.Item label="Retreads">{tyre.retreadCount}</Descriptions.Item>
      <Descriptions.Item label="Tread now">{formatDepth(tyre.currentDepthMm)}</Descriptions.Item>
      <Descriptions.Item label="Distance run">{formatKm(tyre.kmOnTyre)}</Descriptions.Item>
    </Descriptions>
  );
}
